import { MouseEvent, ReactNode } from 'react';
import Spinner from '../Spinner';
import styles from './style.module.scss';

type ButtonType =
    'Primary' |
    'Secondary' |
    'Error' |
    'Light' |
    'Link' |
    'Outline-Primary' |
    'Outline-Dark' |
    'Outline-Error';

interface Props {
    size?: 'sm' | 'md' | 'lg';
    text: string;
    onClick?: any;
    disabled?: boolean;
    type?: ButtonType;
    className?: string;
    loading?: boolean;
    icon?: ReactNode;
};

function Button(props: Props) {
    const {
        type,
        icon,
        text,
        size,
        onClick,
        disabled,
        className,
        loading,
    } = props;

    const clickFunc = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onClick();
    };

    return (
        <button
            className={`${styles.button}${className ? ` ${className}` : ''}`}
            onClick={clickFunc}
            data-button-type={type}
            data-button-size={size}
            disabled={disabled || loading}
        >
            {loading ? <Spinner /> : <span>{text}</span>}
            {(icon && !loading) && icon}
        </button>
    );
};

export default Button;
